import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap, withLatestFrom, exhaustMap, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as serviceActions from '../store/actions/delivery-requests.action';
import { DeliveryRequestService } from '../services/delivery-requests.service';
import { EMPTY } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { editService } from '../store/actions/delivery-requests.action';
import * as ridersActions from "../../riders/store/actions/riders.action";


@Injectable()
export class DeliveryRequestEffects {


loadServices$ = createEffect(() => this.actions$.pipe(
  ofType(serviceActions.loadServices),
  exhaustMap((action) =>
    this.deliveryRequestService.getServices(action.page, action.limit, action.query)
    .pipe(
      tap(services => console.log('Services loaded from server', services)),
      map(services => serviceActions.loadServicesSuccess({ services })),
      catchError(() => EMPTY)
    ))
  )
);


createService$ = createEffect(() =>
  this.actions$.pipe(
    ofType(serviceActions.createService),
    withLatestFrom(this.store.select((state:any) => state.request)),
    mergeMap(([action, serviceState]) => {
     
      const service = serviceState.service;
      return this.deliveryRequestService.createService(service).pipe(
        map(service => {
          this.snackBar.open('Servicio creado exitosamente', 'Cerrar', {
            duration: 3000,
          });
          return serviceActions.createServiceSuccess({ service });
        }),
        catchError(() => {
          this.snackBar.open(
            'Los datos ingresados no son correctos o no se han rellenado todos los campos. Por favor verifica tus datos e intenta nuevamente',
            'Cerrar',
            {
              duration: 3000
            }
          );
          return of(serviceActions.createServiceFailure({ error: 'Error' }));
        })
      )
    }),
    tap(() => this.store.dispatch(serviceActions.loadServices({ page: 1, limit: 5, query: '' })))
  )
);

editService$ = createEffect(() => 
this.actions$.pipe(
  ofType(serviceActions.editService),
  withLatestFrom(this.store.select((state:any) => state.request)),
  mergeMap(([action, serviceState]) => {
    
    const service = serviceState.request;
    return this.deliveryRequestService.editService(action.id, service).pipe(
      map(service => {
        this.snackBar.open('Servicio editado exitosamente', 'Cerrar', {
          duration: 3000,
        });
        return serviceActions.editServiceSuccess({ service});
      }),
      catchError(() => {
        this.snackBar.open(
          'Los datos ingresados no son correctos o no se han rellenado todos los campos. Por favor verifica tus datos e intenta nuevamente',
          'Cerrar',
          {
            duration: 3000
          }
        );
        return of(serviceActions.editServiceFailure({ error: 'Error' }));
      })
    )
  }),
  tap(() => this.store.dispatch(serviceActions.loadServices({ page: 1, limit: 5, query: '' })))
)
);
   

 assignDeliveryRequest$ = createEffect(() =>
  this.actions$.pipe(
    ofType(serviceActions.assignDeliveryRequest),
    mergeMap((action) =>
      this.deliveryRequestService.assignDeliveryRequest(action.service_id, action.rider_id).pipe(
        map(service => {
          this.snackBar.open('Servicio asignado exitosamente', 'Cerrar', {
            duration: 3000,
          });
          return serviceActions.assignDeliveryRequestSuccess({ service });
        }),
        catchError(() => {
          this.snackBar.open(
            'No se pudo asignar el servicio. Por favor intenta nuevamente',
            'Cerrar',
            {
              duration: 3000
            }
          );
          return of(serviceActions.assignDeliveryRequestFailure({ error: 'Error' }));
        })
      )
    )
  )
);

assignedDeliverySuccess$ = createEffect(() =>
  this.actions$.pipe(
    ofType(serviceActions.assignDeliveryRequestSuccess),
    concatMap(() => of(
      ridersActions.loadRidersLocations(),
      serviceActions.loadServices({ page: 1, limit: 5, query: '' })
    ))
  )
);
  
  
  
 
 


 
 

  constructor(
    private actions$: Actions,
    private deliveryRequestService: DeliveryRequestService,
    private store : Store,
    private snackBar: MatSnackBar,
  ) {}
}

